import { orderBy } from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import ActivitiesLog from "shared/components/ActivitiesLog";
import EmailLogDrawer from "shared/components/EmailLogDrawer";
import Loading from "shared/components/Spin";
import { NAME_SPACES } from "shared/locales/constants";
import { ACTIVITY_FILTERS } from "utils/constants";
import { activitySortTime } from "utils/helpers/date";

const SubscriptionActivities = ({
  isPageLoading,
  qualificationActivities,
  statusActivities,
  callActivities,
  emailActivities,
  whatsappActivities,
  hasMoreCalls,
  handleLoadMoreCalls,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTACT);
  const [activeFilter, setActiveFilter] = useState(ACTIVITY_FILTERS.ALL);
  const [selectedEmailLogId, setSelectedEmailLogId] = useState(null);

  const filters = [
    { key: ACTIVITY_FILTERS.ALL, label: t("ACTIVITIES.FILTERS.ALL") },
    { key: ACTIVITY_FILTERS.CALLS, label: t("ACTIVITIES.FILTERS.CALLS") },
    {
      key: ACTIVITY_FILTERS.QUALIFICATIONS,
      label: t("ACTIVITIES.FILTERS.QUALIFICATIONS"),
    },
    {
      key: ACTIVITY_FILTERS.STATUSES,
      label: t("ACTIVITIES.FILTERS.STATUSES"),
    },
    { key: ACTIVITY_FILTERS.EMAILS, label: t("ACTIVITIES.FILTERS.EMAILS") },
    {
      key: ACTIVITY_FILTERS.WHATSAPP,
      label: t("ACTIVITIES.FILTERS.WHATSAPP"),
    },
  ];

  if (isPageLoading) {
    return <Loading />;
  }

  let filtered = [];
  if (activeFilter === ACTIVITY_FILTERS.ALL) {
    filtered = [
      ...qualificationActivities,
      ...statusActivities,
      ...callActivities,
      ...emailActivities,
      ...whatsappActivities,
    ];
  } else if (activeFilter === ACTIVITY_FILTERS.CALLS) {
    filtered = callActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.QUALIFICATIONS) {
    filtered = qualificationActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.STATUSES) {
    filtered = statusActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.EMAILS) {
    filtered = emailActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.WHATSAPP) {
    filtered = whatsappActivities;
  }

  const activities = orderBy(
    filtered,
    (activity) => activitySortTime(activity.date),
    "desc",
  );

  return (
    <div className="activities-tab">
      <div className="activities-tab__filters">
        {filters.map(({ key, label }) => (
          <button
            key={key}
            className={classNames("activities-tab__filter", {
              "activities-tab__filter--active": activeFilter === key,
            })}
            onClick={() => setActiveFilter(key)}
          >
            {label}
          </button>
        ))}
      </div>
      {!activities.length ? (
        <div className="no-activity">{t("ACTIVITIES.NO_ACTIVITY")}</div>
      ) : (
        <ActivitiesLog
          activities={activities}
          hasMore={hasMoreCalls}
          onLoadMore={handleLoadMoreCalls}
          onOpenEmail={({ id }) => setSelectedEmailLogId(id)}
        />
      )}
      <EmailLogDrawer
        open={!!selectedEmailLogId}
        emailLogId={selectedEmailLogId}
        onClose={() => setSelectedEmailLogId(null)}
      />
    </div>
  );
};

SubscriptionActivities.propTypes = {
  isPageLoading: PropTypes.bool,
  qualificationActivities: PropTypes.array,
  statusActivities: PropTypes.array,
  callActivities: PropTypes.array,
  emailActivities: PropTypes.array,
  whatsappActivities: PropTypes.array,
  hasMoreCalls: PropTypes.bool,
  handleLoadMoreCalls: PropTypes.func,
};

SubscriptionActivities.defaultProps = {
  isPageLoading: false,
  qualificationActivities: [],
  statusActivities: [],
  callActivities: [],
  emailActivities: [],
  whatsappActivities: [],
  hasMoreCalls: false,
  handleLoadMoreCalls: () => {},
};

export default SubscriptionActivities;
